export const analyticsEnvironment = {
  GOOGLE_ANALYTICS: {
    domain: 'auto',
    trackingId: 'UA-114317102-2',
    GTM: ''
  }
};
